import { Component, h } from '@monygroupcorp/microact';

export class BalanceDisplay extends Component {
    constructor(props) {
        super(props);
        this.eventBus = props.eventBus;
        this.state = {
            balances: props.balances || { eth: '0', exec: '0', lastUpdated: null },
            loading: props.loading !== undefined ? props.loading : true,
            error: props.error || null,
        };
    }

    didMount() {
        if (this.eventBus) {
            this.subscribe('balances:updated', this.bind(this.handleBalanceUpdate));
        }
    }

    handleBalanceUpdate(balances) {
        this.setState({ balances, loading: false, error: null });
    }

    render() {
        const { balances, loading, error } = this.state;

        const classNames = ['balance-display', 'marble-bg'];
        if (loading) classNames.push('loading');
        if (error) classNames.push('error');

        return h('div', { className: classNames.join(' ') },
            h('div', { className: 'balance-header' },
                h('h3', null, 'Your Balances'),
                balances.lastUpdated && h('span', { className: 'last-updated' },
                    `Last updated: ${new Date(balances.lastUpdated).toLocaleTimeString()}`
                )
            ),

            h('div', { className: 'balance-content' },
                loading
                    ? h('div', { className: 'loading-indicator' }, 'Loading balances...')
                    : error
                        ? h('div', { className: 'error-message' }, error)
                        : h('div', { className: 'balance-grid' },
                            h('div', { className: 'balance-item eth' },
                                h('span', { className: 'label' }, 'ETH Balance'),
                                h('span', { className: 'amount' }, balances.eth)
                            ),
                            h('div', { className: 'balance-item exec' },
                                h('span', { className: 'label' }, 'EXEC Balance'),
                                h('span', { className: 'amount' }, balances.exec)
                            )
                        )
            )
        );
    }
}
